import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { StarjackProvider } from '@starjack/core';
import App from './App';

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <HelmetProvider>
            <BrowserRouter>
                <StarjackProvider config={{ application: 'Admin' }}>
                    <App />
                </StarjackProvider>
            </BrowserRouter>
        </HelmetProvider>
    </React.StrictMode>
);
